import { Box, Card, Typography, useTheme } from "@mui/material";
import { colors } from "../../../../theme/muiColors";
// import { TimePeriod } from "../../../clients/interfaces/TimePeriod.interface";
import { ETimePeriods } from "../../enums/timesheets.enum";
import { MetricCard } from "./MetricCard";

import { useGetWorkforceAnalaytics } from "../../hooks/useGetWorkforceAnalytics";
import { useGetCompanyHours } from "../../hooks/useGetCompanyHours";

export const MetricsSection = ({ timePeriod, enableLabel }: { timePeriod: ETimePeriods, enableLabel: boolean }) => {
    const theme = useTheme();

    const { data: workforceAnalytics, isLoading: isAnalyticsLoading } = useGetWorkforceAnalaytics(timePeriod);
    const { data: companyHours, isLoading: isHoursLoading } = useGetCompanyHours(timePeriod);

    console.log("workforceAnalytics", workforceAnalytics);
    console.log("companyHours", companyHours);

    return (
        <Card
            sx={{
                borderRadius: 3,
                border: `1px solid ${theme.palette.divider}`,
                boxShadow: "0 4px 20px -2px rgba(0, 0, 0, 0.05), 0 2px 10px -2px rgba(0, 0, 0, 0.03)",
                bgcolor: "var(--fx-surface-base, #FFFFFF)",
                overflow: "hidden",
                mb: 1,
            }}
        >
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                    borderBottom: { xs: `1px solid ${theme.palette.divider}`, md: "none" },
                    "& > *:first-of-type": {
                        borderRight: { xs: "none", md: `1px solid ${theme.palette.divider}` },
                    },
                }}
            >
                <MetricCard
                    title="Worked Hours"
                    color={colors.orange[400]}
                    enableLabel={enableLabel}
                    data={{ data: companyHours }}
                    isLoading={isHoursLoading}
                    onSetTimePeriod={() => { }}
                    change={0}
                />
                <MetricCard
                    title="Workforce Change"
                    color={colors.blue[300]}
                    enableLabel={enableLabel}
                    data={{ data: workforceAnalytics }}
                    isLoading={isAnalyticsLoading}
                    onSetTimePeriod={() => { }}
                    change={0}
                />

            </Box>

        </Card>
    );
};
